import { p as F, c as j } from "../../styled-components.browser.esm-DBaC0ZEI.mjs";
import * as o from "react";
import Z, { forwardRef as ee, useRef as W, useImperativeHandle as re } from "react";
import { z as ae, i as te, q as R, f as q, o as ne, _ as z, a as H, D as oe, s as ce, v as B } from "../../index-CjjiqU7h.mjs";
import { u as le, a as K } from "../../useCSSVarCls--o7XUl-F.mjs";
import { T as se, W as ie } from "../../index-CmPT-VFE.mjs";
import { F as de } from "../../context-CqAjIyj3.mjs";
import { u as U } from "../../index-BZFW3CAo.mjs";
import { o as ue } from "../../omit-B_u6A-HL.mjs";
var be = ["prefixCls", "className", "style", "checked", "disabled", "defaultChecked", "type", "title", "onChange"], pe = /* @__PURE__ */ ee(function(e, b) {
  var l = e.prefixCls, r = l === void 0 ? "rc-checkbox" : l, c = e.className, V = e.style, k = e.checked, h = e.disabled, _ = e.defaultChecked, m = _ === void 0 ? !1 : _, d = e.type, g = d === void 0 ? "checkbox" : d, P = e.title, n = e.onChange, w = ae(e, be), v = W(null), u = W(null), a = le(m, {
    value: k
  }), O = te(a, 2), N = O[0], C = O[1];
  re(b, function() {
    return {
      focus: function(i) {
        var f;
        (f = v.current) === null || f === void 0 || f.focus(i);
      },
      blur: function() {
        var i;
        (i = v.current) === null || i === void 0 || i.blur();
      },
      input: v.current,
      nativeElement: u.current
    };
  });
  var p = R(r, c, q(q({}, "".concat(r, "-checked"), N), "".concat(r, "-disabled"), h)), s = function(i) {
    h || ("checked" in e || C(i.target.checked), n == null || n({
      target: z(z({}, e), {}, {
        type: g,
        checked: i.target.checked
      }),
      stopPropagation: function() {
        i.stopPropagation();
      },
      preventDefault: function() {
        i.preventDefault();
      },
      nativeEvent: i.nativeEvent
    }));
  };
  return /* @__PURE__ */ o.createElement("span", {
    className: p,
    title: P,
    style: V,
    ref: u
  }, /* @__PURE__ */ o.createElement("input", ne({}, w, {
    className: "".concat(r, "-input"),
    ref: v,
    onChange: s,
    disabled: h,
    checked: !!N,
    type: g
  })), /* @__PURE__ */ o.createElement("span", {
    className: "".concat(r, "-inner")
  }));
});
const fe = /* @__PURE__ */ Z.createContext(null), X = fe;
var he = function(e, b) {
  var l = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && b.indexOf(r) < 0 && (l[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var c = 0, r = Object.getOwnPropertySymbols(e); c < r.length; c++)
      b.indexOf(r[c]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[c]) && (l[r[c]] = e[r[c]]);
  return l;
};
const ve = (e, b) => {
  var l;
  const {
    prefixCls: r,
    className: c,
    rootClassName: V,
    children: k,
    indeterminate: h = !1,
    style: _,
    onMouseEnter: m,
    onMouseLeave: d,
    skipGroup: g = !1,
    disabled: P
  } = e, n = he(e, ["prefixCls", "className", "rootClassName", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup", "disabled"]), {
    getPrefixCls: w,
    direction: v,
    checkbox: u
  } = o.useContext(H), a = o.useContext(X), {
    isFormItemInput: O
  } = o.useContext(de), N = o.useContext(oe), C = (l = (a == null ? void 0 : a.disabled) || P) !== null && l !== void 0 ? l : N, p = o.useRef(n.value);
  if (process.env.NODE_ENV !== "production") {
    const t = ce("Checkbox");
    process.env.NODE_ENV !== "production" && t("checked" in n || !!a || !("value" in n), "usage", "`value` is not a valid prop, do you mean `checked`?");
  }
  o.useEffect(() => {
    a == null || a.registerValue(n.value);
  }, []), o.useEffect(() => {
    if (!g)
      return n.value !== p.current && (a == null || a.cancelValue(p.current), a == null || a.registerValue(n.value), p.current = n.value), () => a == null ? void 0 : a.cancelValue(n.value);
  }, [n.value]);
  const s = w("checkbox", r), x = K(s), [i, f, I] = U(s, x), y = Object.assign({}, n);
  a && !g && (y.onChange = function() {
    n.onChange && n.onChange.apply(n, arguments), a.toggleOption && a.toggleOption({
      label: k,
      value: n.value
    });
  }, y.name = a.name, y.checked = a.value.includes(n.value));
  const D = R(`${s}-wrapper`, {
    [`${s}-rtl`]: v === "rtl",
    [`${s}-wrapper-checked`]: y.checked,
    [`${s}-wrapper-disabled`]: C,
    [`${s}-wrapper-in-form-item`]: O
  }, u == null ? void 0 : u.className, c, V, I, x, f), G = R({
    [`${s}-indeterminate`]: h
  }, se, f), M = h ? "mixed" : void 0;
  return i(/* @__PURE__ */ o.createElement(ie, {
    component: "Checkbox",
    disabled: C
  }, /* @__PURE__ */ o.createElement("label", {
    className: D,
    style: Object.assign(Object.assign({}, u == null ? void 0 : u.style), _),
    onMouseEnter: m,
    onMouseLeave: d
  }, /* @__PURE__ */ o.createElement(pe, Object.assign({
    "aria-checked": M
  }, y, {
    prefixCls: s,
    className: G,
    disabled: C,
    ref: b
  })), k !== void 0 && /* @__PURE__ */ o.createElement("span", null, k))));
}, L = /* @__PURE__ */ o.forwardRef(ve);
process.env.NODE_ENV !== "production" && (L.displayName = "Checkbox");
var xe = function(e, b) {
  var l = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && b.indexOf(r) < 0 && (l[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var c = 0, r = Object.getOwnPropertySymbols(e); c < r.length; c++)
      b.indexOf(r[c]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[c]) && (l[r[c]] = e[r[c]]);
  return l;
};
const ke = /* @__PURE__ */ o.forwardRef((e, b) => {
  const {
    defaultValue: l,
    children: r,
    options: c = [],
    prefixCls: V,
    className: k,
    rootClassName: h,
    style: _,
    onChange: m
  } = e, d = xe(e, ["defaultValue", "children", "options", "prefixCls", "className", "rootClassName", "style", "onChange"]), {
    getPrefixCls: g,
    direction: P
  } = o.useContext(H), [n, w] = o.useState(d.value || l || []), [v, u] = o.useState([]);
  o.useEffect(() => {
    "value" in d && w(d.value || []);
  }, [d.value]);
  const a = o.useMemo(() => c.map((t) => typeof t == "string" || typeof t == "number" ? {
    label: t,
    value: t
  } : t), [c]), O = (t) => {
    u((E) => E.filter((S) => S !== t));
  }, N = (t) => {
    u((E) => [].concat(B(E), [t]));
  }, C = (t) => {
    const E = n.indexOf(t.value), S = B(n);
    E === -1 ? S.push(t.value) : S.splice(E, 1), "value" in d || w(S), m == null || m(S.filter((A) => v.includes(A)).sort((A, J) => {
      const Q = a.findIndex((T) => T.value === A), Y = a.findIndex((T) => T.value === J);
      return Q - Y;
    }));
  }, p = g("checkbox", V), s = `${p}-group`, x = K(p), [i, f, I] = U(p, x), y = ue(d, ["value", "disabled"]), D = c.length ? a.map((t) => /* @__PURE__ */ o.createElement(L, {
    prefixCls: p,
    key: t.value.toString(),
    disabled: "disabled" in t ? t.disabled : d.disabled,
    value: t.value,
    checked: n.includes(t.value),
    onChange: t.onChange,
    className: `${s}-item`,
    style: t.style,
    title: t.title,
    id: t.id,
    required: t.required
  }, t.label)) : r, G = {
    toggleOption: C,
    value: n,
    disabled: d.disabled,
    name: d.name,
    // https://github.com/ant-design/ant-design/issues/16376
    registerValue: N,
    cancelValue: O
  }, M = R(s, {
    [`${s}-rtl`]: P === "rtl"
  }, k, h, I, x, f);
  return i(/* @__PURE__ */ o.createElement("div", Object.assign({
    className: M,
    style: _
  }, y, {
    ref: b
  }), /* @__PURE__ */ o.createElement(X.Provider, {
    value: G
  }, D)));
}), me = ke, $ = L;
$.Group = me;
$.__ANT_CHECKBOX = !0;
process.env.NODE_ENV !== "production" && ($.displayName = "Checkbox");
const Se = F($)`
  ${({
  design: e
}) => e === "border-design" && j`
      .ant-checkbox .ant-checkbox-inner {
        border: 1px solid var(--gray-5);
      }

      .ant-checkbox-checked .ant-checkbox-inner {
        background: var(--gray-1);
        border: 1px solid var(--purple-7);
      }

      .ant-checkbox-checked .ant-checkbox-inner::after {
        border: 1.5px solid var(--primary-7);
        border-top: 0;
        border-left: 0;

        &:hover {
          background: var(--gray-1);
        }
      }

      .ant-checkbox-disabled {
        &.ant-checkbox-checked .ant-checkbox-inner {
          background: var(--gray-3);
          border: 1px solid var(--gray-5);
        }

        &.ant-checkbox-checked .ant-checkbox-inner::after {
          border-color: var(--gray-6);
        }
      }

      &.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover
        .ant-checkbox-checked:not(.ant-checkbox-disabled)
        .ant-checkbox-inner {
        background-color: var(--gray-1);
        border-color: var(--primary-7);
      }
    `}
`, Ve = F($.Group)`
  ${({
  design: e
}) => e === "border-design" && j`
      .ant-checkbox .ant-checkbox-inner {
        border: 1px solid var(--gray-5);
      }

      .ant-checkbox-checked .ant-checkbox-inner {
        background: var(--gray-1);
        border: 1px solid var(--purple-7);
      }

      .ant-checkbox-checked .ant-checkbox-inner::after {
        border: 1.5px solid var(--primary-7);
        border-top: 0;
        border-left: 0;

        &:hover {
          background: var(--gray-1);
        }
      }

      .ant-checkbox-disabled {
        &.ant-checkbox-checked .ant-checkbox-inner {
          background: var(--gray-3);
          border: 1px solid var(--gray-5);
        }

        &.ant-checkbox-checked .ant-checkbox-inner::after {
          border-color: var(--gray-6);
        }
      }

      .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover
        .ant-checkbox-checked:not(.ant-checkbox-disabled)
        .ant-checkbox-inner {
        background-color: var(--gray-1);
        border-color: var(--primary-7);
      }
    `}

  ${({
  layout: e
}) => e === "column" && j`
      display: flex;
      flex-direction: column;
      gap: var(--space-12);
      flex-wrap: nowrap;
      .ant-checkbox-wrapper + .ant-checkbox-wrapper {
        margin-inline-start: 0;
      }
    `}

  ${({
  scroll: e
}) => e === "mac" && j`
      &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 7px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.2);
        -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
      }
    `}
`;
export {
  Ve as StyledCheckBoxGroup,
  Se as StyledCheckbox
};
//# sourceMappingURL=style.js.map
